export const COLOR_PALETTE = [
    'rgba(90, 102, 206, 1)',
    'rgba(234, 145, 37, 1)',
    'rgba(198, 71, 188, 1)',
    'rgba(71, 170, 118, 1)',
    'rgba(174, 201, 52, 1)',
    'rgba(192, 119, 31, 1)',
    'rgba(163, 59, 154, 1)',
    'rgba(74, 84, 169, 1)',
    'rgba(59, 140, 97, 1)',
    'rgba(143, 165, 43, 1)',
    'rgba(239, 175, 96, 1)',
    'rgba(213, 121, 206, 1)',
    'rgba(135, 143, 219, 1)',
    'rgba(121, 193, 155, 1)',
    'rgba(196, 215, 107, 1)',
]
